module.exports = __webpack_public_path__ + "static/media/sonicgenerations.25895059.png";